import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { preChatActions, sitesActions } from '@/redux/modules';
import useAgentsFactory from '@/hooks/agentsFactory/useAgentsFactory';
import useSupergatorSso from '@/hooks/useSupergatorSso';

const SUPERGATOR_PRODUCT_IDS = [530, 533, 536, 551];

const useAgentsPage = () => {
  const dispatch = useDispatch();
  const { openAgentsFactory } = useAgentsFactory();
  const { redirectToSupergator, loading: ssoLoading } = useSupergatorSso();

  const { productsLoading, productsList } = useSelector(state => state.preChat);
  const { agentsFactory } = useSelector(state => state.sites);

  const isLoading = useMemo(() => (
    productsLoading || ssoLoading || (agentsFactory && agentsFactory.loading)
  ), [productsLoading, ssoLoading, agentsFactory]);

  const isEligible = useMemo(() => (
    agentsFactory && agentsFactory.account && agentsFactory.account.eligible
  ), [agentsFactory]);

  const hasSupergatorProduct = useMemo(() => (
    productsList.hostings && productsList.hostings.some(
      product => SUPERGATOR_PRODUCT_IDS.includes(Number(product.package_id)),
    )
  ), [productsList]);

  const loadAgentsPageResources = () => {
    dispatch(preChatActions.productByStatus.request({ withCancelled: true, withPending: true }));
    dispatch(sitesActions.agentsFactory.account.request());
  };

  useEffect(loadAgentsPageResources, [dispatch]);

  const redirectIfSupergatorProduct = () => {
    if (hasSupergatorProduct) {
      redirectToSupergator();
    }
  };

  useEffect(redirectIfSupergatorProduct, [hasSupergatorProduct]); // eslint-disable-line react-hooks/exhaustive-deps

  const openAgentsFactoryWhenEligible = () => {
    if (isEligible) {
      openAgentsFactory('home');
    }
  };

  useEffect(openAgentsFactoryWhenEligible, [isEligible]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    isLoading: !!(isLoading || isEligible || hasSupergatorProduct),
  };
};

export default useAgentsPage;
